import axios from 'axios';
import qs from 'qs';
import { sessionService } from 'redux-react-session';
import { API_BASE_URL, getHeaders } from '../constants/apiConf';



function transformGetParams(params) {
  let paramsString = '?';

  Object
    .keys(params)
    .map((param, index) => {
      paramsString += (index > 0) ? '&' : '';
      paramsString += `${param}=${params[param]}`;

      return param;
    });

  return paramsString;
}


function getFormDataParams(params) {
  const formData = new FormData();
  Object
    .keys(params)
    .map((paramKey) => {
      formData.append(paramKey, params[paramKey]);
      return paramKey;
    });
  return formData;
}

async function apiRequest(method, url, params, isFormData = false) {
  const headers = await getHeaders();
  const CONFIG = {
    method,
    headers,
  };
  let URL = `${API_BASE_URL}/${url.endPoint}`;
  if (params) {
    if (typeof params === 'object') {
      switch (method) {
        case 'GET':
        case 'DELETE':
          URL += transformGetParams(params);
          break;

        case 'POST':
        case 'PUT':
        default:
          if (isFormData) {
            if (isFormData === true) {
              CONFIG.data = params;
            } else if (isFormData === 1) {
              const formData = new FormData();
              Object.keys(params).forEach((key) => {
                formData.append(key, params[key]);
              });
              CONFIG.data = formData;
            } else if (isFormData === 2) {
              CONFIG.data = getFormDataParams(params);
              CONFIG.headers = new Headers({ ...headers, 'content-type': 'multipart/form-data' });
            }
          } else {
            CONFIG.headers['content-type'] = 'application/x-www-form-urlencoded';
            CONFIG.data = qs.stringify(params);
          }
          break;
      }
    }
  }

  CONFIG.url = URL;
  return axios(CONFIG)
    .then(response => response.data)
    .catch((error) => {
      throw error;
    });
}

export const callServer = (method, serverUrl, params) => {
  let url = serverUrl;
  const CONFIG = {
    method,
    headers: {},
  };
  if (params) {
    if (typeof params === 'object') {
      switch (method) {
        case 'GET':
        case 'DELETE':
          url += transformGetParams(params);
          break;

        case 'POST':
        case 'PUT':
        default:
          CONFIG.headers['content-type'] = 'application/x-www-form-urlencoded';
          CONFIG.data = qs.stringify(params);
          break;
      }
    }
  }

  CONFIG.url = url;
  return axios(CONFIG)
    .then(response => response.data)
    .catch((error) => {
      throw error;
    });
};


async function apiFetch(method, url, parameters, isFormData) {
  const params = parameters || {};
  if (process.env.NODE_ENV === 'development') {
    params.sb = 'develop_torres';
  }
  let makeCall = false;
  return sessionService.loadUser()
    .then((userData) => {
      params.session_user = userData.id;
      params.session_code = userData.user_code;
      params.instance = userData.instance;
      makeCall = true;
      return apiRequest(method, url, params, isFormData);
    })
    .catch((err) => {
      if (!makeCall) {
        return apiRequest(method, url, params, isFormData);
      }
      throw err;
    });
}

export const uploadFile = (file, type = '') => {
  const params = {
    document_file: file,
    type,
  };

  return apiFetch('POST', { endPoint: 'upload-resource' }, params, 1);
};

export default apiFetch;



// WEBPACK FOOTER //
// ./src/utils/apiFetch.js